var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01611 10.1172V29.9089C4.01611 30.5387 4.26634 31.1428 4.71173 31.5882C5.15713 32.0336 5.76122 32.2839 6.39111 32.2839H23.8078C24.4377 32.2839 25.0418 32.0336 25.4872 31.5882C25.9326 31.1428 26.1828 30.5387 26.1828 29.9089V10.1172H4.01611Z",
    stroke: "#F42A41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76611 14.7245V27.6762M15.0994 14.7245V27.6762M21.4328 14.7245V27.6762M9.55778 5.10261V3.37836C9.55778 2.29061 10.5505 1.40869 11.7744 1.40869H18.4244C19.6484 1.40869 20.6411 2.29061 20.6411 3.37836V5.10419",
    stroke: "#F42A41",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9746 5.36719H3.22461C1.91293 5.36719 0.849609 6.43051 0.849609 7.74219C0.849609 9.05386 1.91293 10.1172 3.22461 10.1172H26.9746C28.2863 10.1172 29.3496 9.05386 29.3496 7.74219C29.3496 6.43051 28.2863 5.36719 26.9746 5.36719Z",
    stroke: "#F42A41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.266a017c.svg";
export { ForwardRef as ReactComponent };